import React, { useEffect, useState } from 'react'
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate'
import { FundingHistoryData, ColumnFundingHistory } from '../../../types/TablesTypes/fundingHistory'
import client from '../../../api/client'
import showToast from '../../../components/CustomToast/toastHelper'
import { numberWithCommas } from '../../../utils/formatNumber'
import moment, { Moment } from 'moment'
import { FaEllipsisH } from 'react-icons/fa'
import { useCurrency } from '../../../contexts/CurrencyContext'
const FundingHistory = () => {
  const [filters, setFilters] = useState<any>({
    fromDate: "",
    toDate: "",
    direction:""
  })
  const [fundingHistory,setFundingHistory] = useState<any>()
  const [tableRow, setTableRow] = useState<any[]>()
  const [loading, setLoading] = useState<boolean>(true);

  const {currency} = useCurrency()
  const [isExport, setIsExport] = useState<boolean>(false)
  const [isExportReady, setIsExportReady] = useState<boolean>(false);
  const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

  const clickExport = async () => {
    setIsExport(true);
    setIsExportLoading(true)
    await fetchFundingHistory();

    if (fundingHistory && fundingHistory.items?.length > 0) {
      setIsExportReady(true);
    }

    setIsExportLoading(false);
  };
  useEffect(() => {
    const fetchData = async () => {
        setLoading(true)
        await fetchFundingHistory();
        setLoading(false)
    };
    fetchData();
}, [filters]);


const fetchFundingHistory = async () => {
    try {
        const apiUrl = '/subsidiary/dashboard/fetch/funding/history';
        const params = new URLSearchParams(filters).toString();
        const response = await client.get(`${apiUrl}?${params}`);

        setFundingHistory(response.data.data);
        const message = response?.data?.message;

    } catch (err: any) {
        if (err?.response?.data?.message === 'Please login again') {
            sessionStorage.clear();
            window.location.href = '/';
        } else {
            const message = err?.response?.data?.message;
            console.error('error getting data', err);
            showToast(message, "error");
        }
    }
};

const dataTransaction = () => {
  const tempArr: FundingHistoryData[] = [];
  fundingHistory?.items
    ?.slice(0)
    .reverse()
    .forEach((transaction: any, index: number) => {
      tempArr.push({
        amount: `${transaction.currency} ${numberWithCommas(transaction.amount)}`,
        method: transaction.method ?? "N/A",
        fee: transaction.fee,
        date: (moment.utc(transaction?.dateCreated).local() as Moment).format('DD MMM YYYY hh:mm:ss a'),
        action: <FaEllipsisH/>,
      });
    });
  return tempArr;
};

useEffect(() => {
  setTableRow(dataTransaction());
}, [fundingHistory?.items]);
  return (
    <div>
      <DashboardPagesTemplate
        apiUrl=''
        title='Funding History'
        dataToExport={fundingHistory?.items}
        onFilterChange={setFilters }
        data={tableRow ? tableRow : []}
        headings={ColumnFundingHistory}
        exportButtonExists={true}
        ctaButtonExists={false}
        buttonLabel=''
        buttonIcon=''
        showSearch={false}
        filters={filters}
        dropdownItems={[]}
        datepickerExists={false}
        emptyMessage={`You do not have any funding history in ${currency}`}
        loading={loading}
        clickExportButton={clickExport}
        exportButtonLoading={isExportLoading}
        exportButtonClicked={isExport}
      />
    </div>
  )
}

export default FundingHistory
